document.addEventListener('alpine:init', () => {
    const locale = window.locale;

    try {
        Alpine.store('message', {
            categories: [],
            totalItems: 0,
            perPage: 9,
            currentPage: 1,
            activeCategory: null,

            async fetchData(page = 1) {
                try {
                    const response = await fetch(`/api/v1/messages?page=${page}&perPage=${this.perPage}`, {
                        headers: { 'X-localization': locale }
                    });
                    const data = await response.json();
                    this.categories = data.data;
                    this.totalItems = data.meta.total;
                    this.currentPage = page;
                    this.updatePagination();
                } catch (error) {
                    console.error(error);
                }
            },

            mounted() {
                this.fetchData();
            },

            updatePagination() {
                const paginationContainer = document.querySelector('.pagination');
                if (!paginationContainer) return;
                paginationContainer.innerHTML = '';

                const totalPages = Math.ceil(this.totalItems / this.perPage);
                if (totalPages > 1) {
                    this.renderPagination();
                }
            },

            generatePaginationArray() {
                const totalPages = Math.ceil(this.totalItems / this.perPage);
                if (totalPages <= 1) return [];

                const currentPage = this.currentPage;
                const delta = 2;
                const range = [];
                const start = Math.max(2, currentPage - delta);
                const end = Math.min(totalPages - 1, currentPage + delta);

                for (let i = start; i <= end; i++) range.push(i);

                if (start > 2) range.unshift('...');
                if (end < totalPages - 1) range.push('...');

                range.unshift(1);
                if (totalPages !== 1) range.push(totalPages);

                return range;
            },

            renderPagination() {
                const paginationArray = this.generatePaginationArray();
                const paginationContainer = document.querySelector('.pagination');

                paginationArray.forEach(page => {
                    const pageItem = document.createElement('div');
                    pageItem.className = `item ${page === this.currentPage ? 'item-active' : ''}`;
                    pageItem.textContent = page;

                    if (page !== '...') {
                        pageItem.addEventListener('click', () => {
                            this.currentPage = page;
                            this.activeCategory
                                ? this.fetchDataByCategory(this.activeCategory, null, page)
                                : this.fetchData(page);
                        });
                    } else {
                        pageItem.classList.add('dots');
                    }

                    paginationContainer.appendChild(pageItem);
                });
            }
        });

        Alpine.store('message').mounted();
    } catch (e) {
        console.log("Error", e);
    }
});
